// extracted by mini-css-extract-plugin
export default {"mfeDatadogMask":"PGA+XGoiIpKJ-iQx7dXCLA=="};